module.exports = __webpack_public_path__ + "static/media/ΛΑΓΟΣ ΧΕΛΩΝΑ (ΟΝΓ).7596dbf3.mp4";